import { getAuth } from 'firebase/auth';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export const getTeacherNotifications = async () => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      throw new Error('User is not authenticated.');
    }

    // Get the teacher's document where uid matches
    const teacherQuery = query(
      collection(db, 'teachers'),
      where('uid', '==', user.uid)
    );
    const teacherSnapshot = await getDocs(teacherQuery);

    const teacherDoc = teacherSnapshot.docs[0];

    if (!teacherDoc) {
      throw new Error('Teacher document not found.');
    }

    // Access the notifications sub-collection
    const notificationsRef = collection(db, 'teachers', teacherDoc.id, 'notifications');
    const notificationsSnapshot = await getDocs(notificationsRef);

    // Fetch all notifications with full_name, postId, and other details
    const notifications = notificationsSnapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id, // Include the document ID
        full_name: data.fullName || 'Student', 
        groupId: data.groupId || 'Unknown', 
        postId: data.postId || 'Unknown', 
      };
    });

    return notifications;
  } catch (error) {
    console.error('Error fetching teacher notifications:', error);
    return [];
  }
};
